import { render, staticRenderFns } from "./CompanyHistorical.vue?vue&type=template&id=caac0240&scoped=true"
import script from "./CompanyHistorical.vue?vue&type=script&lang=js"
export * from "./CompanyHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caac0240",
  null
  
)

export default component.exports